module.exports = __webpack_public_path__ + "static/data/project.07ff6c5.json";